import { useState, useEffect } from 'react';
import { Table, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import api from '../api';
import { Link } from 'react-router-dom';

export default function SalesList() {
  const { user } = useAuth();
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSales = async () => {
      try {
        const { data } = await api.get('/sales');
        setSales(data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load sales');
      } finally {
        setLoading(false);
      }
    };
    fetchSales();
  }, []);

  const handleDelete = async (saleId) => {
    if (window.confirm('Are you sure you want to delete this sale? This will restore stock!')) {
      try {
        await api.delete(`/sales/${saleId}`);
        setSales(sales.filter(s => s._id !== saleId));
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to delete sale');
      }
    }
  };

  return (
    <div className="mt-4">
      <h3>Sales History</h3>
      {error && <Alert variant="danger">{error}</Alert>}
      
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Date</th>
              <th>Items</th>
              <th>Total Quantity</th>
              <th>Total Amount</th>
              <th>Total Gross Profit</th>
              <th>Payment Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {sales.map(sale => (
              <tr key={sale._id}>
                <td>{new Date(sale.saleDate).toLocaleDateString()}</td>
                <td>
                  {sale.items?.map((item, index) => (
                    <div key={index}>
                      {item.item?.type || 'Deleted Item'} 
                      (Qty: {item.quantity || 0}, 
                      Price: Ksh{(item.unitPrice || 0).toFixed(2)})
                    </div>
                  ))}
                </td>
                <td>
                  {sale.items?.reduce((sum, item) => sum + (item.quantity || 0), 0)}
                </td>
                <td>Ksh{(sale.totalAmount || 0).toFixed(2)}</td>
                <td className="text-success">
                  Ksh{(sale.totalProfit || 0).toFixed(2)}
                </td>
                <td>
                  {sale.paymentType ? 
                    sale.paymentType.charAt(0).toUpperCase() + sale.paymentType.slice(1) : 
                    'Unknown'}
                </td>
                <td>
                  <div className="d-flex gap-2">
                    <Button 
                      as={Link}
                      to={`/sales/edit/${sale._id}`}
                      variant="info" 
                      size="sm"
                    >
                      Edit
                    </Button>
                    <Button 
                      variant="danger" 
                      size="sm" 
                      onClick={() => handleDelete(sale._id)}
                    >
                      Delete
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
}